
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DBInit from './DBInit';
import Info from './Info';
import LoadToDB from './LoadToDB';
import { Container } from 'react-bootstrap';
import AssignStudies from './AssignStudies';

import '../style/Home.css';

// TODO : Should be restricted to admin only

function Management() {

    return (
        <Container className="container my-5">
            <Tabs
                defaultActiveKey="overview-trainees"
                id="admin-management-tabs"
                className="mb-3"
                variant='tabs'
                fill={true}
                justify={true}
            >
                <Tab eventKey="manage" title="Manage">
                    <DBInit></DBInit>
                </Tab>

                <Tab eventKey="overview-trainees" title="Overview-Trainees">
                    <Info dbName={ 'trainee' }></Info>
                </Tab>
                <Tab eventKey="overview-supervisors" title="Overview-Supervisors">
                    <Info dbName={ 'supervisor' }></Info>
                </Tab>
                <Tab eventKey="overview-admin" title="Overview-Admin">
                    <Info dbName={ 'admin' }></Info>
                </Tab>

                <Tab eventKey="load-trainees" title="Load-Trainees">
                    <LoadToDB dbName={ 'trainee' }></LoadToDB>
                </Tab>
                <Tab eventKey="load-study" title="Assign-Studies">
                    <AssignStudies></AssignStudies>
                </Tab>
                <Tab eventKey="load-supervisors" title="Load-Supervisors">
                    <LoadToDB dbName={ 'supervisor' }></LoadToDB>
                </Tab>
                <Tab eventKey="load-admin" title="Load-Admin">
                    <LoadToDB dbName={ 'admin' }></LoadToDB>
                </Tab>

            </Tabs>
        </Container>
    );
}

export default Management;